export function isChildVisible(parentNode: HTMLElement | string, node: HTMLElement, offset = 0) {
    let parentTop, parentLeft, parentHeight, parentWidth, parent;

    if (typeof parentNode === 'string') {
        parent = document.querySelector(parentNode);
    } else {
        parent = parentNode;
    }

    const defaultBoundingClientRect = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
    };
    try {
        ({
            top: parentTop,
            left: parentLeft,
            height: parentHeight,
            width: parentWidth,
        } = parent.getBoundingClientRect());
    } catch (_e) {
        ({
            top: parentTop,
            left: parentLeft,
            height: parentHeight,
            width: parentWidth,
        } = defaultBoundingClientRect);
    }

    const windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;

    // calculate top and height of the intersection of the element's scrollParent and viewport
    const intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
    const intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport
    const intersectionHeight =
        Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
    const intersectionWidth =
        Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width

    // check whether the element is visible in the intersection
    let top, left, height, width;

    try {
        ({ top, left, height, width } = node.getBoundingClientRect());
    } catch (_e) {
        ({ top, left, height, width } = defaultBoundingClientRect);
    }

    const offsetTop = top - intersectionTop; // element's top relative to intersection
    const offsetLeft = left - intersectionLeft; // element's left relative to intersection

    const offsets = Array.isArray(offset) ? offset : [offset, offset]; // Be compatible with previous API
    return (
        offsetTop - offsets[0] <= intersectionHeight &&
        offsetTop + height + offsets[1] >= 0 &&
        offsetLeft - offsets[0] <= intersectionWidth &&
        offsetLeft + width + offsets[1] >= 0
    );
}
